// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__9T4WC","rightAdornment":"Header_rightAdornment__3P7Kg"};